import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    noSurprises: 'No surprises, no hidden fees',
    regulated: 'Regulated by the ACPR',
    submitButton: 'Pay {amount} VAT incl.',
    title: 'Payment',
    trusted: 'Trusted by more than {customers} customers',
    unknownError: 'Oops! There was an unknown error',
    youWillBeChargedPlural:
      'Your subscription includes {trialPeriod} months of Shine (fees not included). If you continue to use your account after your {trialPeriod} included months, your subscription will automatically be charged to your Shine account or your card if there isn’t enough money on your account.',
    youWillBeChargedSingular:
      'Your subscription includes one month of Shine (fees not included). If you continue to use your account after your included month, your subscription will automatically be charged to your Shine account or your card if there isn’t enough money on your account.',
  },
  fr: {
    noSurprises: 'Pas de frais cachés ni de mauvaises surprises',
    regulated: 'Établissement agréé par l’ACPR',
    submitButton: 'Payer {amount} TTC',
    title: 'Paiement',
    trusted: 'Plus de {customers} clients nous font déjà confiance',
    unknownError: 'Oups! Une erreur inconnue est survenue',
    youWillBeChargedPlural:
      'Votre abonnement comprend {trialPeriod} mois de Shine (commissions non incluses) Si vous continuez à utiliser votre compte après vos {trialPeriod} mois inclus, votre abonnement sera automatiquement prélevé sur votre compte Shine ou sur votre carte si votre solde est insuffisant.',
    youWillBeChargedSingular:
      'Votre abonnement comprend un mois de Shine (commissions non incluses) Si vous continuez à utiliser votre compte après votre mois inclus, votre abonnement sera automatiquement prélevé sur votre compte Shine ou sur votre carte si votre solde est insuffisant.',
  },
} as const);
